import React from "react";
import { Link } from "react-router-dom";
import Meta from "../components/Meta";

const styles = [
  {
    emoji: "📷",
    title: "Hyper-Realistic Breasts",
    description:
      "Photo-quality breast images with pore-level skin detail, natural sag and weight, accurate nipple shading, and soft golden-hour or studio lighting. Looks like a real shoot.",
  },
  {
    emoji: "🌸",
    title: "Anime / Oppai",
    description:
      "Exaggerated bust sizes, smooth gradient shading, and the iconic oppai look from hentai and ecchi art. Large, bouncy, perfectly stylized — exactly how anime does it.",
  },
  {
    emoji: "🖌️",
    title: "Illustrated / Painterly",
    description:
      "Soft brushstroke style with rich skin tones and artistic composition. Captures the feel of a high-quality NSFW commission with a warm, handcrafted aesthetic.",
  },
  {
    emoji: "💠",
    title: "3D / CGI",
    description:
      "Rendered breast shapes with smooth, glossy skin, perfect symmetry, subsurface light scattering, and depth-of-field blur. Looks sculpted and polished.",
  },
  {
    emoji: "🧝",
    title: "Fantasy Chest",
    description:
      "Busty elves, demon queens, warrior women with barely-there armor — fantasy art where large, exposed chests are part of the world-building and visual story.",
  },
  {
    emoji: "🎞️",
    title: "Retro / Pin-Up",
    description:
      "Full, natural breasts celebrated in classic pin-up form — warm Kodachrome tones, playful poses, low necklines, and that confident 1950s–60s glamour aesthetic.",
  },
];

const prompts = [
  {
    style: "Realistic",
    prompt:
      "topless woman, massive natural breasts, soft window light, lying on white sheets, photorealistic skin texture, freckles, shallow depth of field, Sony A7R, 8K RAW",
  },
  {
    style: "Realistic 2",
    prompt:
      "curvy brunette, huge heavy breasts barely covered by open shirt, golden-hour backlight, outdoor setting, realistic skin pores, candid portrait, ultra-detailed",
  },
  {
    style: "Anime",
    prompt:
      "anime girl, enormous oppai, tight wet t-shirt, nipples visible, embarrassed blush, soft cell-shading, detailed linework, vibrant pastel background, ecchi style",
  },
  {
    style: "Anime 2",
    prompt:
      "hentai style, busty maid outfit, huge breasts spilling out of corset, big expressive eyes, smooth gradient shading, high contrast, clean illustration, 4K",
  },
  {
    style: "3D CGI",
    prompt:
      "3D CGI render, naked busty woman, perfect spherical large breasts, glossy skin, octane render, studio three-point lighting, subsurface scattering, ultra-smooth, 4K",
  },
  {
    style: "Fantasy",
    prompt:
      "fantasy warrior woman, enormous exposed breasts, torn revealing armor, glowing magical runes on skin, moonlit forest, dramatic lighting, oil painting style, hyper-detailed",
  },
];

const reasons = [
  {
    emoji: "🎯",
    title: "Specify Breast Size Precisely",
    text: "Small, medium, large, huge, massive — the AI understands every descriptor. Combine with body type (petite, curvy, athletic) and you get exactly the proportions you want.",
  },
  {
    emoji: "👗",
    title: "Dressed, Undressed, or Anywhere Between",
    text: "Generate topless, in lingerie, in a half-open shirt, or completely nude. Describe clothing or the lack of it and the AI respects every detail.",
  },
  {
    emoji: "🔒",
    title: "Private — Nothing Is Saved",
    text: "Your prompts and images are not logged, stored, or shared. Everything generated is for your eyes only. No history, no profile, no trace.",
  },
  {
    emoji: "🔁",
    title: "Tune Until It's Exactly Right",
    text: 'Not the right cup size? Add "bigger" or "smaller". Wrong skin tone? Describe it differently. Regenerate in 10 seconds until the breast shape matches your vision.',
  },
  {
    emoji: "🌍",
    title: "Any Body Type, Any Ethnicity",
    text: "Describe skin tone, body type, age range, and features in your prompt. The AI generates diverse body types without restriction — no default 'standard' body.",
  },
  {
    emoji: "💳",
    title: "Free Generations to Start",
    text: "You get free credits the moment you sign up — no credit card required. Generate your first AI boobs images immediately and upgrade only if you want more.",
  },
];

const GenerateButton = ({ text = "Generate AI Boobs Free →" }) => (
  <Link
    to="/create"
    className="bg-gradient group relative inline-flex whitespace-nowrap rounded-full border-2 border-white/90 px-8 py-3 text-center text-lg font-black text-white transition hover:scale-105 hover:border-white active:scale-110"
    style={{ backgroundImage: "linear-gradient(to left top,#ec008c,#fc6767)" }}
  >
    <div className="absolute inset-0 -m-2 animate-pulse rounded-full bg-white/20 transition group-hover:bg-pink-500/30" />
    {text}
  </Link>
);

const AiBoobs = () => {
  return (
    <>
      <Meta
        title="AI Boobs Generator – Create Realistic & Anime AI Boobs Art"
        description="Generate stunning AI boobs images in any style — realistic, anime, 3D, fantasy and more. Free to start. No sign-up required. Instant high-quality NSFW AI art."
        meta={{ robots: "index, follow" }}
      />

      <main className="flex-auto bg-background-body">

        {/* ── HERO ── */}
        <section className="relative mx-auto flex flex-col items-center justify-center sm:flex-row overflow-hidden px-3 md:px-0">

          {/* Left images */}
          <div className="z-10 hidden w-full items-center justify-center justify-items-center gap-4 overflow-hidden py-4 sm:grid sm:grid-cols-2 sm:overflow-visible lg:max-w-xs lg:px-4">
            {[
              { src: "/boobs-1.png", label: "Beach",   rotate: -3,  translate: "0px, 0px",  scale: "2.0", origin: "center 40%" },
              { src: "/boobs-4.png", label: "Natural", rotate: 2,   translate: "0px, 8px",  scale: "1.5", origin: "center 55%" },
              { src: "/boobs-6.png", label: "Curvy",   rotate: -4,  translate: "0px, -6px", scale: "2.0", origin: "center 38%" },
              { src: "/boobs-8.png", label: "Fantasy", rotate: 3,   translate: "0px, 4px",  scale: "1.8", origin: "center 52%" },
            ].map(({ src, label, rotate, translate, scale, origin }, i) => (
              <Link
                key={`left-${i}`}
                to="/create"
                title={`Generate ${label} AI boobs`}
                className="group relative overflow-hidden rounded-xl border-2 border-white/20 transition hover:scale-105 hover:border-pink-400 hover:shadow-lg hover:shadow-pink-500/20 active:scale-110"
                style={{ transform: `translate(${translate}) rotate(${rotate}deg)` }}
              >
                <div className="overflow-hidden w-[140px] h-[140px]">
                  <img
                    alt={`${label} AI boobs`}
                    width={140}
                    height={140}
                    src={src}
                    style={{
                      color: "transparent",
                      transform: `scale(${scale})`,
                      transformOrigin: origin,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: origin,
                    }}
                  />
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent px-2 py-1">
                  <span className="text-xs font-bold text-white">{label}</span>
                </div>
              </Link>
            ))}
          </div>

          {/* Center */}
          <div
            className="relative z-10 flex flex-col items-center py-10 sm:py-16 lg:px-6 text-center"
            style={{ background: "radial-gradient(ellipse 80% 80% at 50% 50%, rgba(236,0,140,0.18) 0%, transparent 70%)" }}
          >
            <h1 className="mb-2 flex flex-col items-center text-[56px] md:text-[80px] font-black leading-none">
              <span>AI</span>
              <span
                className="!bg-cover !bg-clip-text !bg-center text-transparent"
                style={{ background: "linear-gradient(to top left,#ec008c,#fc6767)" }}
              >
                Boobs
              </span>
              <span className="text-4xl md:text-5xl">Generator 🔥</span>
            </h1>
            <p className="mb-6 max-w-md text-base text-foreground/70">
              Generate any breast style you can imagine — realistic, anime, 3D, fantasy. Describe the size, shape, and look. Done in seconds.
            </p>
            <GenerateButton />
            <div className="mt-4 flex flex-col items-center gap-1 text-xs text-foreground/50">
              <div className="text-yellow-500 text-base">★★★★★</div>
              <span>2,000,000+ images generated</span>
            </div>
          </div>

          {/* Right images */}
          <div className="z-10 grid w-full items-center justify-center justify-items-center gap-4 overflow-hidden py-4 grid-cols-2 sm:grid-cols-2 sm:overflow-visible lg:max-w-xs lg:px-4">
            {[
              { src: "/boobs-2.png", label: "Athletic",  rotate: -3,  translate: "0px, 0px",  scale: "2.0", origin: "center 45%" },
              { src: "/boobs-3.png", label: "Busty",     rotate: 4,   translate: "0px, 6px",  scale: "1.8", origin: "center 52%" },
              { src: "/boobs-5.png", label: "Perky",     rotate: -5,  translate: "0px, -4px", scale: "1.8", origin: "center 62%" },
              { src: "/boobs-7.png", label: "Cleavage",  rotate: 3,   translate: "0px, 8px",  scale: "1.8", origin: "center 52%" },
            ].map(({ src, label, rotate, translate, scale, origin }, i) => (
              <Link
                key={`right-${i}`}
                to="/create"
                title={`Generate ${label} AI boobs`}
                className="group relative overflow-hidden rounded-xl border-2 border-white/20 transition hover:scale-105 hover:border-pink-400 hover:shadow-lg hover:shadow-pink-500/20 active:scale-110"
                style={{ transform: `translate(${translate}) rotate(${rotate}deg)` }}
              >
                <div className="overflow-hidden w-[140px] h-[140px]">
                  <img
                    alt={`${label} AI boobs`}
                    width={140}
                    height={140}
                    src={src}
                    style={{
                      color: "transparent",
                      transform: `scale(${scale})`,
                      transformOrigin: origin,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: origin,
                    }}
                  />
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent px-2 py-1">
                  <span className="text-xs font-bold text-white">{label}</span>
                </div>
              </Link>
            ))}
          </div>

        </section>

        {/* ── WHAT ARE AI BOOBS ── */}
        <section className="bg-black/40 py-16 px-4">
          <div className="mx-auto max-w-3xl text-center">
            <h2 className="mb-6 text-3xl md:text-4xl font-black">What are AI Boobs?</h2>
            <p className="mb-4 text-foreground/70 text-base leading-relaxed">
              AI Boobs are breast-focused images created entirely by artificial intelligence — no real person, no photographer, no studio. You describe the bust size, shape, skin tone, outfit, and lighting you want, and the AI renders it from scratch in seconds. Every image is brand new and generated specifically from your prompt.
            </p>
            <p className="mb-4 text-foreground/70 text-base leading-relaxed">
              Want perky small breasts with a natural look in soft morning light? A massively busty anime girl with a revealing school uniform? A 3D-rendered curvy figure with shiny, glossy skin? Each of those is one text prompt. The AI handles anatomy, lighting, cloth physics, and proportions automatically — you just describe the result you want.
            </p>
            <p className="text-foreground/70 text-base leading-relaxed">
              Unlike searching through content sites or commissioning an artist, AI Boobs generation gives you exactly what you picture in your head — not an approximation, not a compromise. You control breast size, position, outfit (or lack of one), body type, skin texture, and the entire visual mood of the image.
            </p>
            <div className="mt-8">
              <GenerateButton text="Try It Free →" />
            </div>
          </div>
        </section>

        {/* ── HOW TO GENERATE ── */}
        <section className="py-16 px-4">
          <div className="mx-auto max-w-4xl">
            <h2 className="mb-10 text-center text-3xl md:text-4xl font-black">
              How to Generate AI Boobs on This Website
            </h2>
            <div className="grid gap-6 md:grid-cols-3">
              {[
                {
                  step: "1",
                  title: "Open the Generator",
                  desc: "Click any Generate button on this page. You land directly on the creation screen — no account needed to start.",
                },
                {
                  step: "2",
                  title: "Describe the Breasts You Want",
                  desc: 'Be specific: "large natural breasts", "perky small chest", "huge anime oppai", "busty hourglass figure". The more detail, the better the result.',
                },
                {
                  step: "3",
                  title: "Add Body & Scene Details",
                  desc: 'Tell the AI about skin tone, outfit, pose, and setting. Example: "topless, lying on a bed, warm candlelight, lace lingerie pooled around waist".',
                },
                {
                  step: "4",
                  title: "Choose Realistic or Anime",
                  desc: "Realistic style produces photo-quality breast images. Anime style gives you that exaggerated, high-contrast hentai look. Pick based on your preference.",
                },
                {
                  step: "5",
                  title: "Generate & Review",
                  desc: "Your AI boobs image renders in under 10 seconds. If the breast size, shape, or lighting isn't perfect, tweak one word and regenerate.",
                },
                {
                  step: "6",
                  title: "Download Full Resolution",
                  desc: "Download your image instantly — no watermark, no compression. Save your best generations to your private gallery for future reference.",
                },
              ].map(({ step, title, desc }) => (
                <div key={step} className="rounded-lg border border-foreground/10 bg-background/50 p-6 hover:bg-background/80 transition">
                  <div
                    className="mb-4 inline-flex h-10 w-10 items-center justify-center rounded-full text-lg font-black text-white"
                    style={{ background: "linear-gradient(to left top,#ec008c,#fc6767)" }}
                  >
                    {step}
                  </div>
                  <h3 className="mb-2 text-lg font-bold">{title}</h3>
                  <p className="text-sm text-foreground/70">{desc}</p>
                </div>
              ))}
            </div>
            <div className="mt-10 flex justify-center">
              <GenerateButton />
            </div>
          </div>
        </section>

        {/* ── STYLES ── */}
        <section className="bg-black/40 py-16 px-4">
          <div className="mx-auto max-w-4xl">
            <h2 className="mb-4 text-center text-3xl md:text-4xl font-black">
              AI Boobs Styles You Can Generate
            </h2>
            <p className="mb-10 text-center text-foreground/60 text-sm">
              Each style is a completely different model — not just a filter. The same prompt in Realistic vs Anime produces two entirely different works of art.
            </p>
            <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3">
              {styles.map(({ emoji, title, description }) => (
                <div key={title} className="rounded-lg border border-foreground/10 bg-background/50 p-6 hover:bg-background/80 transition">
                  <div className="mb-3 text-4xl">{emoji}</div>
                  <h3 className="mb-2 text-lg font-bold">{title}</h3>
                  <p className="text-sm text-foreground/70">{description}</p>
                </div>
              ))}
            </div>
            <div className="mt-10 flex justify-center">
              <GenerateButton text="Generate Your Style →" />
            </div>
          </div>
        </section>

        {/* ── PROMPTS ── */}
        <section className="py-16 px-4">
          <div className="mx-auto max-w-4xl">
            <h2 className="mb-4 text-center text-3xl md:text-4xl font-black">
              Ready-to-Use Prompts for Every Style
            </h2>
            <p className="mb-10 text-center text-foreground/60 text-sm">
              Copy any prompt below straight into the generator. These are tested and tuned — paste and generate, no editing required.
            </p>
            <div className="grid gap-4 md:grid-cols-2">
              {prompts.map(({ style, prompt }) => (
                <div key={style} className="rounded-lg border border-foreground/10 bg-background/50 p-5 hover:bg-background/80 transition">
                  <div className="mb-2 flex items-center gap-2">
                    <span
                      className="rounded-full px-3 py-0.5 text-xs font-bold text-white"
                      style={{ background: "linear-gradient(to left top,#ec008c,#fc6767)" }}
                    >
                      {style}
                    </span>
                  </div>
                  <p className="font-mono text-sm text-foreground/80 leading-relaxed">"{prompt}"</p>
                  <Link
                    to={`/create`}
                    className="mt-3 inline-block text-xs font-bold text-pink-400 hover:text-pink-300 transition"
                  >
                    Use this prompt →
                  </Link>
                </div>
              ))}
            </div>
            <div className="mt-10 flex justify-center">
              <GenerateButton text="Start Generating →" />
            </div>
          </div>
        </section>

        {/* ── WHY GENERATE AI BOOBS ── */}
        <section className="bg-black/40 py-16 px-4">
          <div className="mx-auto max-w-4xl">
            <h2 className="mb-4 text-center text-3xl md:text-4xl font-black">
              Why Use NSFWArtGenerator.ai?
            </h2>
            <p className="mb-10 text-center text-foreground/60 text-sm max-w-xl mx-auto">
              There are dozens of AI generators out there. Here's what actually makes this one different.
            </p>
            <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3">
              {reasons.map(({ emoji, title, text }) => (
                <div key={title} className="rounded-lg border border-foreground/10 bg-background/50 p-6 hover:bg-background/80 transition">
                  <div className="mb-3 text-4xl">{emoji}</div>
                  <h3 className="mb-2 text-lg font-bold">{title}</h3>
                  <p className="text-sm text-foreground/70">{text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── FAQ ── */}
        <section className="py-16 px-4">
          <div className="mx-auto max-w-4xl">
            <h2 className="mb-4 text-center text-3xl md:text-4xl font-black">
              Frequently Asked Questions
            </h2>
            <p className="mb-10 text-center text-foreground/60 text-sm">
              Everything you need to know about the AI Boobs Generator.
            </p>
            <div className="grid gap-4 md:grid-cols-2">
              {[
                {
                  q: "What is an AI Boobs Generator?",
                  a: "An AI Boobs Generator is a tool that uses machine learning models to create breast-focused images from a text prompt. You describe what you want — size, style, outfit, body type — and the AI renders a unique image in seconds. No real person is involved.",
                },
                {
                  q: "Can I choose the breast size?",
                  a: 'Yes, completely. Just describe it in your prompt — "small perky breasts", "large natural chest", "massive oppai", "huge heavy breasts" — the AI understands and renders accordingly. You can also pair it with body type descriptors for precise results.',
                },
                {
                  q: "Is it free to generate AI boobs?",
                  a: "You get free credits when you create an account — no credit card required. These are enough to generate several images and test different styles. You can upgrade to a paid plan if you want unlimited generations.",
                },
                {
                  q: "Are the images saved or stored?",
                  a: "No. Your prompts and generated images are not logged or stored on our servers. Everything you generate is private. We don't share, sell, or retain any of your content.",
                },
                {
                  q: "Which style gives the most realistic breast images?",
                  a: 'The "Hyper-Realistic" style produces the most photo-accurate results — natural skin texture, proper weight and sag, realistic nipple shading, and lighting that looks like a real photograph. Add "RAW photo, 8K, Sony A7R" to your prompt to push the realism further.',
                },
                {
                  q: "Can I generate anime-style big boobs (oppai)?",
                  a: 'Absolutely. Select the Anime style and use terms like "huge oppai", "enormous bust", "ecchi", or "hentai style" in your prompt. The model is trained on anime aesthetics and produces exaggerated, stylized breast shapes that match the genre.',
                },
                {
                  q: "What prompts work best for AI boobs?",
                  a: 'Be specific about size ("large natural breasts"), coverage ("topless", "open shirt", "lingerie"), lighting ("golden-hour", "studio softbox"), and body type ("petite", "curvy", "athletic"). The more detail you add, the closer the result is to what you imagined.',
                },
                {
                  q: "Can I generate different body types and skin tones?",
                  a: "Yes. The AI generates any body type and skin tone you describe. Include details like \"dark skin\", \"tan\", \"pale\", \"petite frame\", \"plus size\", or \"athletic build\" in your prompt. There is no default body type — it renders exactly what you describe.",
                },
                {
                  q: "How many free generations do I get?",
                  a: "New users receive a set of free credits upon registration, which translates to several AI boobs generations. The exact number depends on the current plan but is enough to explore multiple styles — realistic, anime, 3D — and refine your prompts before deciding whether to upgrade.",
                },
                {
                  q: "Do I need to sign up?",
                  a: "You can browse the page and explore prompts without signing up, but generating images requires a free account. Registration takes under a minute, requires only an email address, and gives you immediate access to free generation credits with no credit card needed.",
                },
                {
                  q: "Is there a watermark?",
                  a: "No. Images generated on NSFWArtGenerator.ai do not have watermarks. Your downloaded image is clean, full-resolution, and yours to use as you like. We do not embed hidden watermarks or logos into any generated content on free or paid plans.",
                },
                {
                  q: "What features are locked behind premium?",
                  a: "Free users have a limited number of generations per day. Premium unlocks unlimited daily generations, higher resolution outputs, faster queue priority, access to advanced model versions, and the ability to save an unlimited number of images in your private gallery.",
                },
                {
                  q: "Is there a daily limit?",
                  a: "Free accounts have a daily generation limit that resets every 24 hours. The limit is generous enough for casual use. If you need to generate large volumes of AI boobs images — for example, iterating through many prompt variations — a premium plan removes the cap entirely.",
                },
                {
                  q: "Is my data private?",
                  a: "Yes. Your prompts, generated images, and account information are kept strictly private. We do not sell user data to third parties, we do not share generation history with advertisers, and your content is never used to train external models without explicit opt-in consent.",
                },
                {
                  q: "Can anyone see my generated images?",
                  a: "No. All generated images are private to your account by default. There is no public feed or discovery section where your creations appear. Other users on the platform cannot browse or access your generated AI boobs images under any circumstances.",
                },
                {
                  q: "Do I need a credit card?",
                  a: "No credit card is required to sign up or use the free tier. You can generate AI boobs images immediately after creating a free account using only your email address. A credit card is only needed if you choose to upgrade to a paid premium plan.",
                },
                {
                  q: "Will this appear on billing statements?",
                  a: "If you upgrade to a paid plan, the charge will appear on your billing statement under our company name — not as 'NSFW' or any explicit descriptor. We use a discreet billing descriptor specifically to protect the privacy of users who access adult content platforms.",
                },
                {
                  q: "Is the site secure?",
                  a: "Yes. The site uses HTTPS encryption on all pages, meaning all data transmitted between your browser and our servers is encrypted. Your account credentials, payment information, and generated content are all handled under secure, industry-standard protocols.",
                },
                {
                  q: "Can I delete generated content?",
                  a: "Yes. Any image you have saved to your gallery can be deleted at any time from your account dashboard. Once deleted, the image is permanently removed from our servers and cannot be recovered. You have full control over your stored content at all times.",
                },
                {
                  q: "How do prompts work?",
                  a: "A prompt is a text description of what you want the AI to generate. The model reads every word and builds the image accordingly. For AI boobs images, describe breast size, body type, clothing or lack of it, skin tone, lighting, and art style. More detail consistently produces better, more accurate results.",
                },
                {
                  q: "Does it support face swap?",
                  a: "The generator currently focuses on full image creation from text prompts rather than face-swapping existing photos. Every image is generated entirely from scratch based on your description. Face swap and image-to-image editing features are on the product roadmap and may be available in a future update.",
                },
                {
                  q: "Can I edit an existing image?",
                  a: "At the moment the tool generates new images from text prompts rather than editing uploaded ones. You can refine results by adjusting your prompt and regenerating. Inpainting and img2img editing — where you upload an image and modify specific areas — is planned for a future release.",
                },
                {
                  q: "Is there an app?",
                  a: "NSFWArtGenerator.ai is currently available as a web application accessible from any browser on desktop or mobile. A dedicated iOS or Android app is not yet available, but the mobile web experience is fully optimized so you can generate AI boobs images directly from your phone without needing to install anything.",
                },
              ].map(({ q, a }, i) => (
                <div
                  key={i}
                  className="rounded-lg border border-foreground/10 bg-background/50 p-6 hover:bg-background/80 transition"
                >
                  <h3 className="mb-3 text-base font-bold">{q}</h3>
                  <p className="text-sm text-foreground/70 leading-relaxed">{a}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── RELATED TOOLS ── */}
        <section className="py-12 px-4 bg-black/40">
          <div className="mx-auto max-w-4xl">
            <h2 className="mb-6 text-center text-xl font-black text-foreground/80">Explore More AI Generators</h2>
            <div className="grid gap-4 sm:grid-cols-2">
              <Link
                to="/create/ai-blowjob-generator"
                className="group flex items-center gap-4 rounded-xl border border-white/10 bg-white/5 p-5 transition hover:border-pink-500/40 hover:bg-white/10"
              >
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-gradient-to-br from-rose-600 to-pink-800 text-2xl">💋</div>
                <div>
                  <div className="font-bold group-hover:text-pink-400 transition">AI Blowjob Generator</div>
                  <div className="text-xs text-foreground/50">Realistic & anime blowjob scenes generated by AI</div>
                </div>
                <span className="ml-auto text-foreground/30 group-hover:text-pink-400 transition">→</span>
              </Link>
              <Link
                to="/ai-nude"
                className="group flex items-center gap-4 rounded-xl border border-white/10 bg-white/5 p-5 transition hover:border-purple-500/40 hover:bg-white/10"
              >
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-gradient-to-br from-purple-700 to-indigo-900 text-2xl">🔥</div>
                <div>
                  <div className="font-bold group-hover:text-purple-400 transition">AI Nude Generator</div>
                  <div className="text-xs text-foreground/50">Generate full nude AI images in any style</div>
                </div>
                <span className="ml-auto text-foreground/30 group-hover:text-purple-400 transition">→</span>
              </Link>
            </div>
          </div>
        </section>

        {/* ── FINAL CTA ── */}
        <section className="py-16 px-4 flex flex-col items-center justify-center text-center bg-black/70">
          <h2 className="mb-3 text-2xl md:text-3xl font-black">Generate the exact bust you have in mind.</h2>
          <p className="mb-6 text-foreground/60 text-sm max-w-md">
            Breast size, skin tone, outfit, pose, style — describe it once and the AI renders it in 10 seconds. Free credits included, no card needed.
          </p>
          <GenerateButton text="Generate AI Boobs Free →" />
        </section>

      </main>
    </>
  );
};

export default AiBoobs;
